import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { QbApplyRequest } from './qb-sync.model';

@Injectable({ providedIn: 'root' })
export class QbSyncService {

    private readonly urlBase = `${environment.apiUrl}/qb-sync`;

    constructor(private http: HttpClient) { }

    getUnlabeledDeposits(startDate: string, endDate: string): Observable<ApiResponse> {
        let params = new HttpParams()
            .set('startDate', startDate)
            .set('endDate', endDate);
        return this.http.get<ApiResponse>(`${this.urlBase}/deposits/unlabeled`, { params }).pipe(retry({ count: 1, delay: 1500 }));
    }

    getMatch(qboDepositId: number): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(`${this.urlBase}/deposits/${qboDepositId}/match`).pipe(retry({ count: 1, delay: 1500 }));
    }

    applyLabels(qboDepositId: number, request: QbApplyRequest): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(`${this.urlBase}/deposits/${qboDepositId}/apply`, request);
    }

    getAuditLog(qboDepositId?: number, appliedBy?: string, page = 0, size = 25): Observable<ApiResponse> {
        let params = new HttpParams()
            .set('page', String(page))
            .set('size', String(size));
        if (qboDepositId != null) { params = params.set('qboDepositId', String(qboDepositId)); }
        if (appliedBy) { params = params.set('appliedBy', appliedBy); }
        return this.http.get<ApiResponse>(`${this.urlBase}/audit`, { params }).pipe(retry({ count: 1, delay: 1500 }));
    }
}
